import { Spreadsheet } from '@syncfusion/ej2-spreadsheet';
import { ExcelDataService } from '../../DataService/ExcelDataService';

import { Grid, Filter, Page, Sort, RecordClickEventArgs, Toolbar } from '@syncfusion/ej2-grids';
import { DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { ModalHelper } from '../../Helpers/ModalHelper';
import { Toastr } from '../../Helpers/Toastr';
import { App } from '../../App';
import { ConfirmModal } from '../../Helpers/ConfirmModal';
import { DynamicVariables } from '../../Common/DynamicVariables';
import { ToValidateStatus } from '../../Models/MailboxPdf/ToValidateStatus';
import { SyncfusionDropdownHelper } from '../../Helpers/SyncfusionDropdownHelper';
import { DatePicker } from '@syncfusion/ej2/calendars';
import { DateHelper } from '../../Helpers/DateHelper';
import { SyncfusionGridHelper } from '../../Helpers/SyncfusionGridHelper';

export class ImportDocHeaderInfoManager {

    constructor(private containerElement: JQuery) { }
    
    private queueGrid : Grid;


    private isUserAdmin : boolean
    

    public initialize() {
        var self = this;

        Grid.Inject(Toolbar, Filter, Page, Sort);

        self.initializeImportDocHeaderTable();
    }

    private initializeImportDocHeaderTable() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var queueGridContainer = self.containerElement.find('#import-data-validate-import-doc-header-container');

        var gridElement : JQuery<HTMLElement> = self.containerElement.find('#ImportToValidateGrid');
        var gridContentElement : JQuery<HTMLElement> = gridElement;
    

        var creationDateElem;
        var creationDateObj;

        let data: DataManager = new DataManager({
            url: '/api/company/import/importdocs',
            adaptor: new WebApiAdaptor
        });

        self.queueGrid = new Grid(
            {
                height: '100%',
                dataSource: data,
                columns: [
                    { field: 'Id', isPrimaryKey: true, visible: false, allowEditing: false, validationRules: { required: true }},
                    { field: 'CreationDateTimeString', headerText: 'Created', autoFit: true, allowEditing: false, allowFiltering: true,
                        filterBarTemplate: {
                            create: () => { 
                                creationDateElem = document.createElement('input'); 
                                return creationDateElem; 
                                }, 
                            write: (args) => {
                                const persistedValue =
                                    args?.value
                                    ?? self.queueGrid?.filterSettings?.columns
                                        ?.find((x: any) => x.field === 'CreationDateTimeString')
                                        ?.value;

                                creationDateObj = new DatePicker({
                                    value: SyncfusionGridHelper.parseDatePickerValue(persistedValue),
                                    format: 'dd-MM-yyyy',
                                    floatLabelType: 'Never',

                                    change: (args) => {
                                        const dateValue = DateHelper.DateToString(args.value);

                                        if (dateValue == undefined) {
                                            self.queueGrid.removeFilteredColsByField(
                                                'CreationDateTimeString'
                                            );
                                        } else {
                                            self.queueGrid.filterByColumn(
                                                'CreationDateTimeString',
                                                'equal',
                                                dateValue,
                                                undefined,
                                                true
                                            );
                                        }
                                    }
                                });

                                creationDateObj.appendTo(creationDateElem);
                            } 
                        }, width: 120, validationRules: { required: true }},
                    { field: 'CreatedByInitials', headerText: '', allowFiltering: false, width: 60, template: '${getCreatedByTemplate(data.CreatedBy, data.CreatedByInitials)}'},
                { field: 'Status', headerText: 'Status', autoFit: true, validationRules: { required: false }, allowSorting: false, allowFiltering: true, width: '120px', filterBarTemplate: SyncfusionDropdownHelper.templateEnumOptionsDropDown(() => self.queueGrid, 'Status', Object.keys(ToValidateStatus).filter(key => isNaN(Number(key))), 
                    (args) => {
                    if (args.value !== 'All') {
                        self.queueGrid.filterByColumn(args.item.parentElement.id.replace('_options', ''), 'equal', args.value, undefined, true);
                    } else {
                        self.queueGrid.removeFilteredColsByField(args.item.parentElement.id.replace('_options', ''));
                    }
                }, 'New')},
                    { field: 'CustomerName', headerText: 'Customer', allowFiltering: true},
                    { field: 'VesselName', headerText: 'Vessel', allowFiltering: true},
                    { field: 'LineCount', headerText: '#', allowFiltering: false, width: 75, textAlign: 'Right'},
                    { field: 'CustomerReference', headerText: 'Cust. ref.', autoFit: true, allowFiltering: true, width: 250 }
                ],
                toolbarTemplate: '#toolbar-template',
                allowSorting: true,
                allowPaging: true,
                allowFiltering: true,
                allowSelection: false,
                enablePersistence: true,
                pageSettings: { pageSize: 50 },
                filterSettings:{
                    columns: [
                        { field: 'Status', value: 'New', operator: 'equal' }
                    ],
                },
                created: () => {
                    gridContentElement = gridContentElement.find('.e-content')
                    loadingContainer.addClass('d-none');
                    queueGridContainer.removeClass('d-none');
                },
                dataBound: () => {
                    gridContentElement.find('[data-bs-toggle="tooltip"]').tooltip({ container: 'body', trigger: 'hover' });
                },
                actionBegin: (args) => {
                    if (!this.queueGrid) {
                        return;
                    }

                    if (SyncfusionGridHelper.isFilterAction(args)) {
                        this.queueGrid.pageSettings.currentPage = 1;
                    }
                },
                recordClick: (args: RecordClickEventArgs) => {
                    if (args.target != undefined && args.rowData != undefined) {
                        var parsedTarget = $(args.target); 
                        var documentId = args.rowData["Id"];

                        var url = `/Company/Import/Validate/${documentId}/Details`;
                        if(DynamicVariables.ControlPressed) {
                            window.open(url, '_blank');
                        }
                        else {
                            location.href = url;
                        }
                    }    
                }
            });
        self.queueGrid.appendTo('#ImportToValidateGrid');

        var toolbar = this.containerElement.find('#toolbar-template');
        if(toolbar != undefined && toolbar.length > 0) {
            var clearFiltersButton = toolbar.find('#clear-filters-button');
            clearFiltersButton.off('click').on('click', () => {
                self.queueGrid.pageSettings.currentPage = 1;
                self.queueGrid.clearFiltering();
                self.queueGrid.refreshHeader();
            })
        }
    }
}